import React from 'react';
var AlertDismissible = function AlertDismissible(_ref) {
  var onDismiss = _ref.onDismiss,
    text = _ref.text,
    type = _ref.type,
    allowDismiss = _ref.allowDismiss;
  return /*#__PURE__*/React.createElement("div", {
    className: "alert alert-".concat(type, " ").concat(allowDismiss ? 'alert-dismissible fade show' : ''),
    role: "alert"
  }, text, allowDismiss && /*#__PURE__*/React.createElement("button", {
    onClick: onDismiss,
    type: "button",
    className: "btn-close",
    "data-bs-dismiss": "alert",
    "aria-label": "Close"
  }));
};
AlertDismissible.defaultProps = {
  type: 'info',
  onDismiss: undefined,
  allowDismiss: true
};
export default AlertDismissible;